import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, vModelDynamic as _vModelDynamic, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_23 = { class: "space-y-4" }
const _hoisted_24 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 dark:border-gray-700 pb-2 gap-3" }
const _hoisted_25 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_26 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = ["type"]
const _hoisted_30 = {
  key: 0,
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_31 = {
  key: 1,
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_32 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_33 = { class: "mt-3 space-y-2" }
const _hoisted_34 = {
  key: 0,
  class: "flex items-center text-sm font-bold text-amber-600 dark:text-amber-400"
}
const _hoisted_35 = {
  key: 1,
  class: "flex items-center text-sm font-bold text-red-600 dark:text-red-400"
}
const _hoisted_36 = {
  key: 2,
  class: "flex items-center text-sm text-red-600 dark:text-red-400 font-medium"
}
const _hoisted_37 = {
  key: 3,
  class: "flex items-center text-sm text-red-600 dark:text-red-400 font-medium"
}
const _hoisted_38 = {
  key: 4,
  class: "flex items-center text-sm text-red-600 dark:text-red-400 font-medium"
}
const _hoisted_39 = {
  key: 5,
  class: "flex items-center text-sm text-green-600 dark:text-green-400 font-medium"
}
const _hoisted_40 = { class: "mt-8 border-t border-gray-200 dark:border-gray-700 pt-6 space-y-4" }
const _hoisted_41 = { class: "flex items-center justify-between pb-2 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_42 = {
  key: 0,
  class: "inline-flex items-center text-xs text-blue-600 dark:text-blue-400"
}
const _hoisted_43 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-gray-50 dark:bg-gray-800 rounded-lg border dark:border-gray-700 text-gray-500 dark:text-gray-400"
}
const _hoisted_44 = {
  key: 1,
  class: "bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-4 border dark:border-gray-700"
}
const _hoisted_45 = {
  key: 0,
  class: "mb-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700 rounded-lg p-4"
}
const _hoisted_46 = { class: "flex items-start" }
const _hoisted_47 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_48 = { class: "space-y-2" }
const _hoisted_49 = { class: "font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_50 = { class: "text-gray-600 dark:text-gray-300 ml-2" }
const _hoisted_51 = { class: "flex space-x-2" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_55 = { class: "border-t dark:border-gray-600 pt-4" }
const _hoisted_56 = { class: "text-sm font-medium text-gray-700 dark:text-gray-200 mb-3" }
const _hoisted_57 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" }
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_60 = { class: "mb-4" }
const _hoisted_61 = { class: "grid grid-cols-3 md:grid-cols-4 gap-2" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_64 = { class: "flex justify-end space-x-2" }

import { ref, reactive, watch, computed } from 'vue'
import type { Employee } from '@/types/employee'
import { useToastService } from '@/services/toast'
import EmployeeAssignmentService, { 
  type CreateAssignmentPayload
} from '@/services/employee-assignment'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import {
  UserPen,
  AlertTriangle,
  XCircle,
  CheckCircle
} from 'lucide-vue-next'

interface EditEmployeeFormData {
  first_name: string
  last_name: string
  middle_name: string
  email: string
  phone_number: string
  city: string
  state: string
  zip_code: string
  password: string
  password_confirmation: string
  month_assignments?: Array<{
    assigned_year: number
    assigned_months: number[]
  }>
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'EditEmployee',
  props: {
    isVisible: { type: Boolean },
    employee: {}
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Emits
const emit = __emit

// Toast service
const toast = useToastService()

// Form state
const formData = reactive<EditEmployeeFormData>({
  first_name: '',
  last_name: '',
  middle_name: '',
  email: '',
  phone_number: '',
  city: '',
  state: '',
  zip_code: '',
  password: '',
  password_confirmation: '',
  month_assignments: []
})

const errors = ref<Record<string, string>>({})
const isSubmitting = ref(false)
const showPassword = ref(false)
const updatePassword = ref(false)

// Store original data to track changes
const originalFormData = ref<{
  first_name: string
  last_name: string
  middle_name: string
  email: string
  phone_number: string
  city: string
  state: string
  zip_code: string
}>({
  first_name: '',
  last_name: '',
  middle_name: '',
  email: '',
  phone_number: '',
  city: '',
  state: '',
  zip_code: ''
})

// Month assignment state
const isLoadingAssignments = ref(false)
const assignmentsLoaded = ref(false)
const editingAssignmentIndex = ref<number | null>(null)
const hasMonthAccessChanges = ref(false)
const originalMonthAssignments = ref<Array<{
  assigned_year: number
  assigned_months: number[]
}>>([])

// Temporary assignment form for UI manipulation
const tempAssignmentForm = reactive<CreateAssignmentPayload>({
  assigned_year: new Date().getFullYear(),
  assigned_months: []
})

const assignmentErrors = ref<Record<string, string>>({})

// Available years (current year to 5 years ahead)
const availableYears = computed(() => {
  const currentYear = new Date().getFullYear()
  const years = []
  for (let i = 0; i <= 5; i++) {
    years.push(currentYear + i)
  }
  return years
})

// Months data
const months = [
  { value: 1, label: 'Jan' },
  { value: 2, label: 'Feb' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'Apr' },
  { value: 5, label: 'May' },
  { value: 6, label: 'Jun' },
  { value: 7, label: 'Jul' },
  { value: 8, label: 'Aug' },
  { value: 9, label: 'Sep' },
  { value: 10, label: 'Oct' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dec' }
]

// Watch for modal visibility and employee prop changes to populate form and fetch assignments
watch(
  [() => props.isVisible, () => props.employee],
  ([isVisible, employee]) => {
    if (isVisible && employee) {
      formData.first_name = employee.first_name
      formData.last_name = employee.last_name
      formData.middle_name = employee.middle_name || ''
      formData.email = employee.email
      formData.phone_number = employee.phone_number || ''
      formData.city = employee.city || ''
      formData.state = employee.state || ''
      formData.zip_code = employee.zip_code || ''
      formData.password = ''
      formData.password_confirmation = ''
      formData.month_assignments = []

      // Store original values for change detection
      originalFormData.value = {
        first_name: employee.first_name,
        last_name: employee.last_name,
        middle_name: employee.middle_name || '',
        email: employee.email,
        phone_number: employee.phone_number || '',
        city: employee.city || '',
        state: employee.state || '',
        zip_code: employee.zip_code || ''
      }

      // Reset password-related state
      updatePassword.value = false
      errors.value = {}

      // Reset assignment temporary form & changes flag
      resetTempAssignmentForm()
      hasMonthAccessChanges.value = false
      originalMonthAssignments.value = []

      // Automatically fetch current monthly assignments
      loadCurrentAssignments()
    }
  },
  { immediate: true }
)

// Watch updatePassword to clear password fields when disabled
watch(updatePassword, newValue => {
  if (!newValue) {
    formData.password = ''
    formData.password_confirmation = ''
  }
})

// Watch for password changes to auto-update confirmation
watch(
  () => formData.password,
  newPassword => {
    if (updatePassword.value) {
      formData.password_confirmation = newPassword
    }
  }
)

// Live validation computed properties
const isPasswordTooShort = computed(() => {
  return updatePassword.value && formData.password && formData.password.length < 6
})

const isPasswordValidLength = computed(() => {
  return updatePassword.value && formData.password && formData.password.length >= 6
})

const isPasswordMismatch = computed(() => {
  return false // No password confirmation field, so never a mismatch
})

// Name validation computed properties
const isFirstNameEmpty = computed(() => {
  return !formData.first_name || formData.first_name.trim() === ''
})

const isLastNameEmpty = computed(() => {
  return !formData.last_name || formData.last_name.trim() === ''
})

// Email validation
const isEmailInvalid = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return formData.email && formData.email.trim() !== '' && !emailRegex.test(formData.email)
})

const isEmailEmpty = computed(() => {
  return !formData.email || formData.email.trim() === ''
})

const nameValidationMessage = computed(() => {
  if (isFirstNameEmpty.value && isLastNameEmpty.value) {
    return 'First Name and Last Name are required'
  } else if (isFirstNameEmpty.value) {
    return 'First name is required'
  } else if (isLastNameEmpty.value) {
    return 'Last name is required'
  }
  return ''
})

// Check if any form data has changed
const hasFormChanges = computed(() => {
  // Check if basic info has changed
  const basicInfoChanged = 
    formData.first_name !== originalFormData.value.first_name ||
    formData.last_name !== originalFormData.value.last_name ||
    formData.middle_name !== originalFormData.value.middle_name ||
    formData.email !== originalFormData.value.email ||
    formData.phone_number !== originalFormData.value.phone_number ||
    formData.city !== originalFormData.value.city ||
    formData.state !== originalFormData.value.state ||
    formData.zip_code !== originalFormData.value.zip_code

  // Check if password is being updated
  const passwordChanged = updatePassword.value && formData.password !== ''

  // Check if month assignments have changed
  const monthAssignmentsChanged = hasMonthAccessChanges.value

  return basicInfoChanged || passwordChanged || monthAssignmentsChanged
})

// Disable submit button if no changes, form is submitting, or assignments are loading
const isSubmitDisabled = computed(() => {
  return !hasFormChanges.value || isSubmitting.value || isLoadingAssignments.value
})

// Methods
const validateForm = (): boolean => {
  errors.value = {}

  // Use the same validation logic as the live validation
  if (isFirstNameEmpty.value) {
    errors.value.first_name = 'First name is required'
  }

  if (isLastNameEmpty.value) {
    errors.value.last_name = 'Last name is required'
  }

  if (!formData.email.trim()) {
    errors.value.email = 'Email is required'
  } else if (isEmailInvalid.value) {
    errors.value.email = 'Please enter a valid email address'
  }

  // Password validation only if updating password
  if (updatePassword.value) {
    if (!formData.password) {
      errors.value.password = 'Password is required'
    } else if (isPasswordTooShort.value) {
      errors.value.password = 'Password must be at least 6 characters long'
    }
  }

  return Object.keys(errors.value).length === 0
}

const handleSubmit = async () => {
  if (!validateForm() || !props.employee) return

  isSubmitting.value = true

  try {
    // Prepare the update data
    const updateData: any = {
      first_name: formData.first_name.trim(),
      last_name: formData.last_name.trim(),
      middle_name: formData.middle_name.trim() || null,
      email: formData.email.trim(),
      phone_number: formData.phone_number.trim() || null,
      city: formData.city.trim() || null,
      state: formData.state.trim() || null,
      zip_code: formData.zip_code.trim() || null
    }

    // Add password fields only if updating password
    if (updatePassword.value) {
      updateData.password = formData.password
      updateData.password_confirmation = formData.password_confirmation
    }

    // Add month assignments - only include if assignments have been modified
    // This allows sending an empty array to remove all assignments while preventing
    // accidental wiping when only updating details or password
    if (hasMonthAccessChanges.value && formData.month_assignments !== undefined) {
      updateData.month_assignments = formData.month_assignments
    }

    // Import the API service dynamically to avoid circular imports
    const { default: api } = await import('@/services/api')

    // Call the update endpoint
    const response = await api.put(`/users/${props.employee.user_details_id}`, updateData)

    if (response.data.success) {
      // Show success toast message with different messages based on whether password was updated
      if (updatePassword.value) {
        toast.success(
          `${formData.first_name} ${formData.last_name}'s details and password have been updated.`
        )
      } else {
        toast.success(
          `${formData.first_name} ${formData.last_name}'s details have been updated.`
        )
      }

      // Reset change tracking since changes have been saved
      hasMonthAccessChanges.value = false
      
      // Update originalFormData to reflect the saved changes
      originalFormData.value = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        middle_name: formData.middle_name,
        email: formData.email,
        phone_number: formData.phone_number,
        city: formData.city,
        state: formData.state,
        zip_code: formData.zip_code
      }

      // Reset password fields after successful update
      if (updatePassword.value) {
        formData.password = ''
        formData.password_confirmation = ''
        updatePassword.value = false
        showPassword.value = false
      }

      // Emit success event with updated employee data
      emit('success', response.data.data)
      closeModal()
    } else {
      throw new Error(response.data.message || 'Failed to update employee')
    }
  } catch (error: any) {
    console.error('Error updating employee:', error)

    // Handle validation errors from server
    if (error.response?.status === 422 && error.response?.data?.errors) {
      // Convert array errors to string errors
      const apiErrors = error.response.data.errors
      Object.keys(apiErrors).forEach(key => {
        errors.value[key] = Array.isArray(apiErrors[key]) ? apiErrors[key][0] : apiErrors[key]
      })
      const firstField = Object.keys(error.response.data.errors)[0]
      const firstError = error.response.data.errors[firstField][0]
      toast.error('Validation Error', firstError)
    } else {
      // Handle other errors
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to update employee'
      errors.value.general = errorMessage
      toast.error('Update Failed', errorMessage)
    }
  } finally {
    isSubmitting.value = false
  }
}

// Month assignment methods
const loadCurrentAssignments = async () => {
  const currentEmployeeId = props.employee?.user_id
  if (!currentEmployeeId) return

  isLoadingAssignments.value = true
  assignmentsLoaded.value = false
  try {
    const response = await EmployeeAssignmentService.getAllAssignments({
      employee_id: currentEmployeeId
    })

    // If modal was closed or employee changed during request, do not update state
    if (!props.isVisible || props.employee?.user_id !== currentEmployeeId) {
      return
    }

    if (response.success) {
      // Filter assignments for this specific employee
      const employeeAssignments = (response.data || []).filter(
        assignment => assignment.employee_id === currentEmployeeId
      )

      // Convert to form format with sorted months
      formData.month_assignments = employeeAssignments.map(assignment => ({
        assigned_year: assignment.assigned_year,
        assigned_months: [...assignment.assigned_months].sort((a, b) => a - b)
      }))

      // Sort assignments by year
      formData.month_assignments.sort((a, b) => a.assigned_year - b.assigned_year)

      // Store original assignments for comparison
      originalMonthAssignments.value = JSON.parse(JSON.stringify(formData.month_assignments))
      hasMonthAccessChanges.value = false
      assignmentsLoaded.value = true
    }
  } catch (error: any) {
    if (props.isVisible && props.employee?.user_id === currentEmployeeId) {
      console.error('Error loading employee assignments:', error)
      toast.error('Failed to load employee assignments')
    }
  } finally {
    if (props.employee?.user_id === currentEmployeeId) {
      isLoadingAssignments.value = false
    }
  }
}

const getMonthNames = (monthNumbers: number[]): string[] => {
  return monthNumbers.map(num => {
    const month = months.find(m => m.value === num)
    return month ? month.label : num.toString()
  })
}

const toggleMonthInTemp = (monthValue: number) => {
  const index = tempAssignmentForm.assigned_months.indexOf(monthValue)
  if (index === -1) {
    tempAssignmentForm.assigned_months.push(monthValue)
  } else {
    tempAssignmentForm.assigned_months.splice(index, 1)
  }
  // Sort months in ascending order
  tempAssignmentForm.assigned_months.sort((a, b) => a - b)
}

const validateTempAssignmentForm = (): boolean => {
  assignmentErrors.value = {}

  if (!tempAssignmentForm.assigned_year) {
    assignmentErrors.value.assigned_year = 'Year is required'
  }

  if (tempAssignmentForm.assigned_months.length === 0) {
    assignmentErrors.value.assigned_months = 'At least one month must be selected'
  }

  // Check if this year already exists in the form (and not being edited)
  if (formData.month_assignments) {
    const existingYearIndex = formData.month_assignments.findIndex(
      assignment => assignment.assigned_year === tempAssignmentForm.assigned_year
    )
    
    if (existingYearIndex !== -1 && existingYearIndex !== editingAssignmentIndex.value) {
      assignmentErrors.value.assigned_year = 'Assignment for this year already exists'
    }
  }

  return Object.keys(assignmentErrors.value).length === 0
}

const addOrUpdateAssignmentInForm = () => {
  if (!validateTempAssignmentForm()) return

  if (!formData.month_assignments) {
    formData.month_assignments = []
  }

  const newAssignment = {
    assigned_year: tempAssignmentForm.assigned_year,
    assigned_months: [...tempAssignmentForm.assigned_months].sort((a, b) => a - b)
  }

  if (editingAssignmentIndex.value !== null) {
    // Update existing assignment
    formData.month_assignments[editingAssignmentIndex.value] = newAssignment
  } else {
    // Add new assignment
    formData.month_assignments.push(newAssignment)
  }

  // Sort assignments by year
  formData.month_assignments.sort((a, b) => a.assigned_year - b.assigned_year)

  // Mark that changes have been made
  checkForMonthAccessChanges()

  resetTempAssignmentForm()
}

const editAssignmentInForm = (index: number) => {
  if (!formData.month_assignments || !formData.month_assignments[index]) return
  
  const assignment = formData.month_assignments[index]
  editingAssignmentIndex.value = index
  tempAssignmentForm.assigned_year = assignment.assigned_year
  tempAssignmentForm.assigned_months = [...assignment.assigned_months]
  assignmentErrors.value = {}
}

const removeAssignmentFromForm = (index: number) => {
  if (!formData.month_assignments) return

  formData.month_assignments.splice(index, 1)
  
  // Mark that changes have been made
  checkForMonthAccessChanges()
  
  // Reset form if we were editing this assignment
  if (editingAssignmentIndex.value === index) {
    resetTempAssignmentForm()
  } else if (editingAssignmentIndex.value !== null && editingAssignmentIndex.value > index) {
    // Adjust the editing index if it was after the removed item
    editingAssignmentIndex.value--
  }
}

const cancelEditAssignment = () => {
  resetTempAssignmentForm()
}

const resetTempAssignmentForm = () => {
  editingAssignmentIndex.value = null
  tempAssignmentForm.assigned_year = new Date().getFullYear()
  tempAssignmentForm.assigned_months = []
  assignmentErrors.value = {}
}

const checkForMonthAccessChanges = () => {
  // Deep comparison of assignments
  const current = JSON.stringify(
    (formData.month_assignments || []).map(a => ({
      assigned_year: a.assigned_year,
      assigned_months: [...a.assigned_months].sort((x, y) => x - y)
    })).sort((a, b) => a.assigned_year - b.assigned_year)
  )
  const original = JSON.stringify(
    (originalMonthAssignments.value || []).map(a => ({
      assigned_year: a.assigned_year,
      assigned_months: [...a.assigned_months].sort((x, y) => x - y)
    })).sort((a, b) => a.assigned_year - b.assigned_year)
  )
  hasMonthAccessChanges.value = current !== original
}

const closeModal = () => {
  // Check if there are any unsaved changes
  if (hasFormChanges.value) {
    const confirmClose = confirm(
      'You have unsaved changes.\n\n' +
      'Please click "Update Employee" to save these changes.\n\n' +
      'Do you want to close without saving?'
    )
    
    if (!confirmClose) {
      return // Don't close the modal
    }
  }

  // Reset form
  if (props.employee) {
    formData.first_name = props.employee.first_name
    formData.last_name = props.employee.last_name
    formData.middle_name = props.employee.middle_name || ''
    formData.email = props.employee.email
    formData.phone_number = props.employee.phone_number || ''
    formData.city = props.employee.city || ''
    formData.state = props.employee.state || ''
    formData.zip_code = props.employee.zip_code || ''
    
    // Reset original data as well
    originalFormData.value = {
      first_name: props.employee.first_name,
      last_name: props.employee.last_name,
      middle_name: props.employee.middle_name || '',
      email: props.employee.email,
      phone_number: props.employee.phone_number || '',
      city: props.employee.city || '',
      state: props.employee.state || '',
      zip_code: props.employee.zip_code || ''
    }
  }
  formData.password = ''
  formData.password_confirmation = ''

  // Reset state
  errors.value = {}
  isSubmitting.value = false
  updatePassword.value = false
  showPassword.value = false

  // Reset assignment state
  hasMonthAccessChanges.value = false
  originalMonthAssignments.value = []
  formData.month_assignments = []
  isLoadingAssignments.value = false
  assignmentsLoaded.value = false
  resetTempAssignmentForm()

  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Edit Employee",
    subtitle: "Update employee information",
    icon: _unref(UserPen),
    size: "2xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createVNode(BaseButton, {
        text: "Cancel",
        variant: "secondary",
        onClick: closeModal,
        disabled: isSubmitting.value
      }, null, 8, ["disabled"]),
      _createVNode(BaseButton, {
        text: "Update Employee",
        variant: "primary",
        loading: isSubmitting.value,
        "loading-text": "Updating...",
        disabled: isSubmitDisabled.value,
        onClick: handleSubmit
      }, null, 8, ["loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "space-y-6"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900 dark:text-white border-b border-gray-200 dark:border-gray-700 pb-2" }, " Personal Information ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  for: "first_name",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, [
                  _createTextVNode(" First Name "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "first_name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.first_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.first_name
                          }]),
                  placeholder: "Enter first name",
                  required: ""
                }, null, 2), [
                  [_vModelText, formData.first_name]
                ]),
                (errors.value.first_name)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors.value.first_name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  for: "last_name",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, [
                  _createTextVNode(" Last Name "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "last_name",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.last_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.last_name
                          }]),
                  placeholder: "Enter last name",
                  required: ""
                }, null, 2), [
                  [_vModelText, formData.last_name]
                ]),
                (errors.value.last_name)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.value.last_name), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  for: "middle_name",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, " Middle Name ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "middle_name",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.middle_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.middle_name
                          }]),
                  placeholder: "Enter middle name (optional)"
                }, null, 2), [
                  [_vModelText, formData.middle_name]
                ]),
                (errors.value.middle_name)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.value.middle_name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  for: "email",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, [
                  _createTextVNode(" Email Address "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.email) = $event)),
                  type: "email",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.email || isEmailInvalid.value
                          }]),
                  placeholder: "Enter email address",
                  required: ""
                }, null, 2), [
                  [_vModelText, formData.email]
                ]),
                (errors.value.email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value.email), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                  for: "phone_number",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, " Phone Number ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "phone_number",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.phone_number) = $event)),
                  type: "tel",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.phone_number
                          }]),
                  placeholder: "Enter phone number (optional)"
                }, null, 2), [
                  [_vModelText, formData.phone_number]
                ]),
                (errors.value.phone_number)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(errors.value.phone_number), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[17] || (_cache[17] = _createElementVNode("label", {
                  for: "city",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, " City ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "city",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.city) = $event)),
                  type: "text",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.city
                          }]),
                  placeholder: "Enter city (optional)"
                }, null, 2), [
                  [_vModelText, formData.city]
                ]),
                (errors.value.city)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value.city), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[18] || (_cache[18] = _createElementVNode("label", {
                  for: "state",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, " State ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "state",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.state) = $event)),
                  type: "text",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.state
                          }]),
                  placeholder: "Enter state (optional)"
                }, null, 2), [
                  [_vModelText, formData.state]
                ]),
                (errors.value.state)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(errors.value.state), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[19] || (_cache[19] = _createElementVNode("label", {
                  for: "zip_code",
                  class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                }, " Zip Code ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "zip_code",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.zip_code) = $event)),
                  type: "text",
                  class: _normalizeClass(["block w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", {
                            'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                              errors.value.zip_code
                          }]),
                  placeholder: "Enter zip code (optional)"
                }, null, 2), [
                  [_vModelText, formData.zip_code]
                ]),
                (errors.value.zip_code)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(errors.value.zip_code), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900 dark:text-white" }, " Password Update (Optional) ", -1)),
              _createElementVNode("label", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((updatePassword).value = $event)),
                  class: "sr-only peer"
                }, null, 512), [
                  [_vModelCheckbox, updatePassword.value]
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" }, null, -1)),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "ml-3 text-sm font-medium text-gray-900 dark:text-gray-300" }, "Update Password", -1))
              ])
            ]),
            (updatePassword.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, [
                      _createTextVNode(" New Password "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        id: "password",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.password) = $event)),
                        type: showPassword.value ? 'text' : 'password',
                        class: _normalizeClass(["block w-full px-4 py-3 pr-10 text-base border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", { 'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.password }]),
                        placeholder: "Enter new password (minimum 6 characters)",
                        minlength: "6"
                      }, null, 10, _hoisted_29), [
                        [_vModelDynamic, formData.password]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (showPassword.value = !showPassword.value))
                      }, [
                        (!showPassword.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_30, [...(_cache[24] || (_cache[24] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              }, null, -1),
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_31, [...(_cache[25] || (_cache[25] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                              }, null, -1)
                            ]))]))
                      ])
                    ]),
                    (errors.value.password)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(errors.value.password), 1))
                      : _createCommentVNode("", true),
                    _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mt-2 text-xs text-gray-500 dark:text-gray-400" }, " Password must be at least 6 characters long ", -1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            (isPasswordTooShort.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_unref(AlertTriangle), { class: "w-4 h-4 mr-2" }),
                  _createTextVNode(" Password is too short (" + _toDisplayString(formData.password.length) + "/6 characters) ", 1)
                ]))
              : _createCommentVNode("", true),
            (isPasswordMismatch.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                  _cache[28] || (_cache[28] = _createTextVNode(" Passwords do not match ", -1))
                ]))
              : _createCommentVNode("", true),
            (nameValidationMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                  _createTextVNode(" " + _toDisplayString(nameValidationMessage.value), 1)
                ]))
              : _createCommentVNode("", true),
            (isEmailEmpty.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                  _cache[29] || (_cache[29] = _createTextVNode(" Email address is required ", -1))
                ]))
              : (isEmailInvalid.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 mr-2" }),
                    _cache[30] || (_cache[30] = _createTextVNode(" Please enter a valid email address ", -1))
                  ]))
                : _createCommentVNode("", true),
            (
                        !nameValidationMessage.value &&
                        !isEmailEmpty.value &&
                        !isEmailInvalid.value &&
                        (!updatePassword.value || (isPasswordValidLength.value && !isPasswordMismatch.value))
                      )
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_unref(CheckCircle), { class: "w-4 h-4 mr-2" }),
                  _cache[31] || (_cache[31] = _createTextVNode(" All fields are valid ", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 32),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900 dark:text-white" }, " Monthly Module Access ", -1)),
            (isLoadingAssignments.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_42, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("svg", {
                    class: "animate-spin -ml-1 mr-2 h-4 w-4 text-blue-600 dark:text-blue-400",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                  ], -1),
                  _createTextVNode(" Loading access... ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (isLoadingAssignments.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[34] || (_cache[34] = [
                _createElementVNode("svg", {
                  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-blue-600",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1),
                _createElementVNode("span", { class: "text-sm font-medium" }, "Fetching current monthly access...", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-300 mb-3" }, " Set monthly module access for this employee. These will be updated when you save the employee details. ", -1)),
                (hasMonthAccessChanges.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_unref(AlertTriangle), { class: "h-5 w-5 text-amber-600 dark:text-amber-400 mt-0.5 mr-3 flex-shrink-0" }),
                        _cache[35] || (_cache[35] = _createElementVNode("div", null, [
                          _createElementVNode("h4", { class: "text-sm font-semibold text-amber-800 dark:text-amber-200" }, " Unsaved Changes "),
                          _createElementVNode("p", { class: "text-sm text-amber-700 dark:text-amber-300 mt-1" }, [
                            _createTextVNode(" You have made changes to the monthly access. Please click the "),
                            _createElementVNode("span", { class: "font-semibold" }, "\"Update Employee\""),
                            _createTextVNode(" button at the bottom to save these changes. ")
                          ])
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (formData.month_assignments && formData.month_assignments.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-700 dark:text-gray-200 mb-2" }, "Current Access:", -1)),
                      _createElementVNode("div", _hoisted_48, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.month_assignments, (assignment, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "flex items-center justify-between bg-white dark:bg-gray-700 p-3 rounded border dark:border-gray-600"
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_49, _toDisplayString(assignment.assigned_year), 1),
                              _createElementVNode("span", _hoisted_50, " - " + _toDisplayString(getMonthNames(assignment.assigned_months).join(', ')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (editAssignmentInForm(index)),
                                class: "text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 text-sm"
                              }, " Edit ", 8, _hoisted_52),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (removeAssignmentFromForm(index)),
                                class: "text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 text-sm"
                              }, " Remove ", 8, _hoisted_53)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[37] || (_cache[37] = [
                      _createElementVNode("p", { class: "text-sm text-gray-500 dark:text-gray-400 italic bg-white dark:bg-gray-700/50 p-3 rounded border border-dashed border-gray-300 dark:border-gray-600" }, " No monthly module access assigned yet. ", -1)
                    ]))])),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("h4", _hoisted_56, _toDisplayString(editingAssignmentIndex.value !== null ? 'Edit Access' : 'Add Access'), 1),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", null, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1" }, [
                        _createTextVNode(" Year "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((tempAssignmentForm.assigned_year) = $event)),
                        class: _normalizeClass(["w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500", { 'border-red-500': assignmentErrors.value.assigned_year }])
                      }, [
                        _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "Select Year", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: year,
                            value: year
                          }, _toDisplayString(year), 9, _hoisted_58))
                        }), 128))
                      ], 2), [
                        [_vModelSelect, tempAssignmentForm.assigned_year]
                      ]),
                      (assignmentErrors.value.assigned_year)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(assignmentErrors.value.assigned_year), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2" }, [
                      _createTextVNode(" Select Months "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_61, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month) => {
                        return _createElementVNode("button", {
                          key: month.value,
                          type: "button",
                          onClick: ($event: any) => (toggleMonthInTemp(month.value)),
                          class: _normalizeClass([
                              'px-3 py-2 text-sm rounded-md border transition-colors',
                              tempAssignmentForm.assigned_months.includes(month.value)
                                ? 'bg-blue-600 text-white border-blue-600 dark:bg-blue-500 dark:border-blue-500'
                                : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600'
                            ])
                        }, _toDisplayString(month.label), 11, _hoisted_62)
                      }), 64))
                    ]),
                    (assignmentErrors.value.assigned_months)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(assignmentErrors.value.assigned_months), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    (editingAssignmentIndex.value !== null)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: cancelEditAssignment,
                          class: "px-3 py-2 text-sm text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                        }, " Cancel "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: addOrUpdateAssignmentInForm,
                      class: "px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 dark:ring-offset-gray-800"
                    }, _toDisplayString(editingAssignmentIndex.value !== null ? 'Update Access' : 'Add Access'), 1)
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-visible", "icon"]))
}
}

})